import React from "react"
import { ImageElement } from "@kontent-ai/gatsby-components";;
import KontentRichText from "@components/KontentRichText"

const Contact = (linkedItem) => {
    const item = linkedItem.linkedItem
    const imagePosition = item && item.elements && item.elements.image_position && item.elements.image_position.value[0] && item.elements.image_position.value[0].codename
    const wrapText = item && item.elements && item.elements.wrap_text && item.elements.wrap_text.value[0] && item.elements.wrap_text.value[0].codename

    const highlightColor = item.elements.highlight_colour.value[0]?.elements.hex_value____.value;
    
    const dynamicStyle = highlightColor
    ? `
      .location-color-${highlightColor}::before {
        background-color: #${highlightColor};
      }
    `
    : '';
  
    return (
    
      <>
        {highlightColor && <style>{dynamicStyle}</style>}
        <li className={`location-grid__item col-span-6 list-none bg-white relative rounded-md shadow-[0_10px_24px_0_rgba(0,0,0,0.1)] p-6 pt-8 location-preview-card location-color-${item.elements.highlight_colour.value[0] && item.elements.highlight_colour.value[0].elements.hex_value____.value} ${wrapText && wrapText === "yes" && "wrap-text"}`}>
          {item.elements.image.value[0] &&
            <ImageElement
              image={item.elements.image.value[0]}
              alt={item.elements.image.value[0].description ? item.elements.image.value[0].description : item.elements.image.value[0].name}
              width={item.elements.image.value[0].width}
              height={item.elements.image.value[0].height}
              className={`location-preview-card__image max-w-[40%] ${imagePosition && imagePosition === "left" ? "float-left mr-4 mb-4" : "float-right ml-4 mb-4"}`} />}
          <h3 className="location-preview-card__title text-[21px] leading-[30px] mb-0">{item.elements.title && item.elements.title.value}</h3>

          {item.elements.name && <h5 className="text-[18px] leading-[32px] font-bold font-['Sailec']">{item.elements.name.value}</h5>}
          <p>{item.elements.email.value && <>
            <a href={item.elements.email && item.elements.email.value}>{item.elements.email && item.elements.email.value}</a>
          </>}
            {item.elements.phone.value && <>
              <br /><a href={`tel:${item.elements.phone && item.elements.phone.value}`}>{item.elements.phone && item.elements.phone.value}</a>
            </>}
          </p>
          {item.elements.additional_info &&
            <KontentRichText value={item.elements.additional_info} />}
        </li>
      </>
    )
  }
  
  export default Contact